import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, RouterLink, RouterLinkActive, RouterOutlet} from "@angular/router";
import {LocalizeRouterPipe} from "@gilsdav/ngx-translate-router";
import {MatListItem, MatNavList} from "@angular/material/list";
import {SidenavComponent} from "../sidenav/sidenav.component";
import {Subscription} from "rxjs";
import {DjangoApiService} from "../../shared/services/django-api.service";
import {LanguageService} from "../../shared/services/language.service";
import {LangChangeEvent, TranslateService} from "@ngx-translate/core";
import {TruncatePipe} from "../../shared/pipes/truncate.pipe";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-default-layout',
  standalone: true,
  imports: [
    SidenavComponent,
    LocalizeRouterPipe,
    MatListItem,
    MatNavList,
    RouterLink,
    RouterLinkActive,
    RouterOutlet,
    TruncatePipe,
    NgIf
  ],
  templateUrl: './default-layout.component.html',
  styleUrl: './default-layout.component.css'
})
export class DefaultLayoutComponent implements OnInit, OnDestroy {
  categoryData!: any;
  currentLanguage!: string;
  langChangeSubscription: Subscription | null = null;
  private subscriptions: Subscription = new Subscription();

  constructor(
    private _apiService: DjangoApiService,
    private _languageService: LanguageService,
    private _translate: TranslateService) {
  }

  /**
   * Initializes the component.
   * - Sets the current language based on the language service.
   * - Manages subscriptions for the component.
   * - Loads product data.
   *
   * @return {void}
   */
  ngOnInit(): void {
    this.currentLanguage = this._languageService.getLanguage();
    this.manageSubscriptions();
    this.loadCategoryData();
  }

  /**
   * Manages subscriptions for language changes.
   * @private
   * @returns {void}
   */
  private manageSubscriptions(): void {
    this.subscriptions.add(
      this.langChangeSubscription = this._translate.onLangChange.subscribe((event: LangChangeEvent) => {
        this.currentLanguage = event.lang;
      }));
  }

  /**
   * Load product data from the API service, and set it as the data source.
   * @private
   * @returns {void}
   */
  private loadCategoryData() {
    this.subscriptions.add(
      this._apiService.fetchCategoryList().subscribe({
        next: (res: any) => {
          this.categoryData = res;
        },
        error: (error) => {
          console.error('There was an error fetching this product.', error);
        }
      })
    );
  }

  /**
   * Performs necessary cleanup tasks before the component is destroyed.
   *
   * @returns {void}
   */
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

}
